import { createContext, useContext } from 'react'
import type { useEditingLease } from '@/editing-leases/hooks/useEditingLease'

export const TimelineEditingLeaseContext = createContext<ReturnType<typeof useEditingLease>>({
  lease: null,
  canWrite: false,
  initializing: false,
  pending: false,
  enabled: false,
  startEditing: () => {},
  handleError: () => false,
  handleDenial: () => false,
  recordActivity: () => {},
})

export function useTimelineEditingLease() {
  return useContext(TimelineEditingLeaseContext)
}
